/**
 * sticky Add to Cart - mobile
 *
 * Pins the real add-to-cart button (`.product-buy-options__add-wrapper`) to the
 * bottom of the viewport when it scrolls out of view. Moves the real element
 * rather than cloning it, so existing buy logic is reused and there's never a
 * duplicate CTA.
 */
(function () {
    const mq = window.matchMedia('(max-width: 767px)')

    let wrapper, sentinel, spacer, observer

    function build() {
        wrapper = document.querySelector('.product-details .product-buy-options__add-wrapper')
        if (!wrapper || wrapper.dataset.stickyAtc) return !!wrapper
        wrapper.dataset.stickyAtc = 'true'

        // Sentinel marks the button's natural position (the observed target);
        // spacer holds its footprint while it's fixed so nothing jumps.
        sentinel = document.createElement('div')
        sentinel.className = 'js-stickyAtcSentinel product-buy-options__sticky-sentinel'
        sentinel.setAttribute('aria-hidden', 'true')
        wrapper.parentNode.insertBefore(sentinel, wrapper)

        spacer = document.createElement('div')
        spacer.className = 'js-stickyAtcSpacer product-buy-options__sticky-spacer'
        spacer.setAttribute('aria-hidden', 'true')
        wrapper.parentNode.insertBefore(spacer, wrapper.nextSibling)

        observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                release()
            } else {
                stick()
            }
        }, { threshold: 0 })

        return true
    }

    function stick() {
        if (!mq.matches || !wrapper || wrapper.classList.contains('is-stuck')) return
        // Measure the in-flow footprint before pulling the button out of flow.
        spacer.style.height = wrapper.offsetHeight + 'px'
        wrapper.classList.add('is-stuck')
        // Stuck height (includes sticky padding) so open option sheets can clear the bar.
        document.documentElement.style.setProperty('--sticky-atc-height', wrapper.offsetHeight + 'px')
        document.documentElement.classList.add('has-sticky-atc')
    }

    function release() {
        if (!wrapper) return
        wrapper.classList.remove('is-stuck')
        spacer.style.height = ''
        document.documentElement.classList.remove('has-sticky-atc')
        document.documentElement.style.removeProperty('--sticky-atc-height')
    }

    function enable() {
        if (!wrapper && !build()) return
        observer.observe(sentinel)
    }

    function disable() {
        if (observer && sentinel) observer.unobserve(sentinel)
        release()
    }

    function apply() {
        if (mq.matches) {
            enable()
        } else {
            disable()
        }
    }

    function init() {
        apply()
        if (mq.addEventListener) {
            mq.addEventListener('change', apply)
        } else if (mq.addListener) {
            mq.addListener(apply)
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})()
